<ion-app [class]="tenant">
  <ion-router-outlet></ion-router-outlet>
</ion-app>
<cloudia-file-preview-overlay></cloudia-file-preview-overlay>
